import React from 'react';

export const createLucideSidebarIcon = (LucideIcon) => {
  function LucideSidebarIcon({ width, height, className, style, ...rest }) {
    return (
      <LucideIcon
        width={width}
        height={height}
        size={width || height || 18}
        className={className}
        style={style}
        stroke='currentColor'
        fill='none'
        aria-hidden
        {...rest}
      />
    );
  }

  LucideSidebarIcon.displayName = `LucideSidebar(${LucideIcon.displayName || LucideIcon.name || 'Icon'})`;

  return LucideSidebarIcon;
};
